"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutOfStockHandlingType = void 0;
var OutOfStockHandlingType;
(function (OutOfStockHandlingType) {
    OutOfStockHandlingType["DELIVER_LATER"] = "w\u00FCnscht Nachlieferung";
    OutOfStockHandlingType["CONTACT_CUSTOMER"] = "w\u00FCnscht Kontaktaufnahme";
    OutOfStockHandlingType["REPLACE_MEDICAMENT"] = "Ersatzmedikament liefern";
})(OutOfStockHandlingType || (exports.OutOfStockHandlingType = OutOfStockHandlingType = {}));
//# sourceMappingURL=webState.js.map